import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.string.trim.js";
import { __decorate } from "tslib";
import { Vue, Options } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import store from '@/store';
import { USER_ADD } from '@/store/actions/user';
import { User } from '@/store/models/user';
import { capitalize, generateRandomString, isEmail } from '@/utils/util';
import AccountCreationNotificationDialog from "@/components/dialog/PasswordNotificationDialog.vue";
var AddUser = /*#__PURE__*/function (_Vue) {
  function AddUser() {
    var _this;
    _classCallCheck(this, AddUser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, AddUser, [].concat(args));
    _defineProperty(_this, "toggleUserCreationDialog", void 0);
    _defineProperty(_this, "login", '');
    _defineProperty(_this, "firstname", '');
    _defineProperty(_this, "lastname", '');
    _defineProperty(_this, "contact", '');
    _defineProperty(_this, "errorMsg", '');
    _defineProperty(_this, "loading", false);
    _defineProperty(_this, "dialogIsVisible", false);
    _defineProperty(_this, "toggleAccountCreationNotificationDialog", false);
    _defineProperty(_this, "createdUser", null);
    _defineProperty(_this, "createdAccountUrl", null);
    return _this;
  }
  _inherits(AddUser, _Vue);
  return _createClass(AddUser, [{
    key: "addUser",
    value: function addUser() {
      var _this2 = this;
      this.errorMsg = '';
      this.loading = true;
      var user = new User(this.login, this.firstname, this.lastname, this.contact, '');
      var tmpPassword = generateRandomString(30);
      store.dispatch(USER_ADD, {
        user: user,
        tmpPassword: tmpPassword
      }).then(function (resp) {
        _this2.closeUserCreationDialog();
        _this2.createdUser = user;
        _this2.informPassword(user, tmpPassword);
        _this2.loading = false;
        _this2.errorMsg = '';
      }).catch(function (err) {
        _this2.loading = false;
        _this2.errorMsg = err;
      });
    }
  }, {
    key: "fillprofil",
    value: function fillprofil(login) {
      this.login = login;
      if (isEmail(this.login)) {
        var email = this.login.split('@');
        if (email[0].indexOf('.') > -1 || email[0].indexOf('_') > -1) {
          var fullname = email[0].split('.');
          var firstname = fullname[0];
          var lastname = fullname[1];
          if (this.firstname === '') {
            this.firstname = capitalize(firstname);
          }
          if (this.lastname === '') {
            this.lastname = capitalize(lastname);
          }
        } else {
          if (this.firstname === '') {
            this.firstname = capitalize(email[0]);
          }
          if (this.lastname === '') {
            this.lastname = capitalize(email[0]);
          }
        }
        this.contact = this.login;
      }
    }
  }, {
    key: "informPassword",
    value: function informPassword(user, tmpPassword) {
      this.createdAccountUrl = document.location.origin + '/initialize/' + user.login + '/' + tmpPassword;
      this.toggleAccountCreationNotificationDialog = true;
    }
  }, {
    key: "handleLogin",
    value: function handleLogin(login) {
      this.login = login;
    }
  }, {
    key: "handleFirstName",
    value: function handleFirstName(firstname) {
      this.firstname = firstname;
    }
  }, {
    key: "handleLastName",
    value: function handleLastName(lastname) {
      this.lastname = lastname;
    }
  }, {
    key: "handleContact",
    value: function handleContact(contact) {
      this.contact = contact;
    }
  }, {
    key: "shouldDisableSubmit",
    value: function shouldDisableSubmit() {
      var _this$login, _this$firstname, _this$lastname;
      return !((_this$login = this.login) !== null && _this$login !== void 0 && _this$login.trim()) || !((_this$firstname = this.firstname) !== null && _this$firstname !== void 0 && _this$firstname.trim()) || !((_this$lastname = this.lastname) !== null && _this$lastname !== void 0 && _this$lastname.trim());
    }
  }, {
    key: "closeUserCreationDialog",
    value: function closeUserCreationDialog() {
      this.dialogIsVisible = false;
      this.errorMsg = '';
      this.$emit("dialogClose");
    }
  }]);
}(Vue);
__decorate([Prop({
  default: false
})], AddUser.prototype, "toggleUserCreationDialog", void 0);
AddUser = __decorate([Options({
  components: {
    AccountCreationNotificationDialog: AccountCreationNotificationDialog
  },
  watch: {
    toggleUserCreationDialog: function toggleUserCreationDialog() {
      this.dialogIsVisible = this.toggleUserCreationDialog;
    }
  }
})], AddUser);
export default AddUser;